import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDeleteInteractionMutation } from 'src/api/interactions';
import { useGlobalModals } from 'src/contexts/global-modals';

export const useDeleteInteraction = () => {
  const {
    deleteInteractionModal,
    closeDeleteInteractionModal,
    openLoadingModal,
    closeLoadingModal,
  } = useGlobalModals();
  const { deleteInteractionMutation, isPending } =
    useDeleteInteractionMutation();
  const navigate = useNavigate();

  const open = deleteInteractionModal.opened;
  const interactionId = deleteInteractionModal.interactionId;

  const handleConfirm = useCallback(async () => {
    if (!interactionId) {
      return;
    }

    openLoadingModal(
      'Deleting interaction',
      'Please wait while we delete the interaction...'
    );
    closeDeleteInteractionModal();

    try {
      await deleteInteractionMutation(interactionId + 5);
      navigate('/interactions');
    } finally {
      closeLoadingModal();
    }
  }, [
    closeDeleteInteractionModal,
    closeLoadingModal,
    deleteInteractionMutation,
    interactionId,
    navigate,
    openLoadingModal,
  ]);

  const handleClose = useCallback(() => {
    closeDeleteInteractionModal();
  }, [closeDeleteInteractionModal]);

  return {
    handleClose,
    handleConfirm,
    isPending,
    open,
  };
};
